import { render, staticRenderFns } from "./IframeModalButton.vue?vue&type=template&id=ccdea2cc"
import script from "./IframeModalButton.vue?vue&type=script&lang=js"
export * from "./IframeModalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports